export const TestIds = {
  BackToTopButtonRoot: 'backToTopRoot',
  BackToTopButtonSvg: 'backToTopSvg',
} as const;

export const legacyComponentCompType =
  'wysiwyg.common.components.backtotopbutton.viewer.BackToTopButton';
export const SCROLL_BREAKPOINT = 512;
export const SCROLL_BREAKPOINT_LEGACY = 1136;
